import { ContentType } from '../ContentType';
import { Messages } from '../../../../gen-src/Localize';
import { AppUrls } from '../../../app/AppUrls';
import { ConnectedOwnerFilter } from '../../components/filters/quickFilter/OwnerFilter';
import { CommonColumns, IColumnFactoryParameters } from '../../components/listView/ListViewGridColumnGenerator';
import { DateTimeCell } from '../../components/listView/dataGridCells/DateTimeCells';
import { IContentDefinition } from './IContentDefinition';
import { ConnectedModifiedTimeFilter } from '../../components/filters/quickFilter/ModifiedTimeFilter';
import { GetProjectsResult, IProject } from '../httpClient/MetaDataResults';
import GetMetaDataRequests from '../../services/httpClient/GetMetaDataRequests';
import { SearchResponseHitsContent } from '../../../generated/content-exploration';
import { UserMapper } from '../../../common/utils/UserMapper';
import { IUser } from '../IUser';
import { Project } from '../SearchResultTypes';
import { SortBy } from '../SortSelection';
import { defaultHeaderFormatter } from '../../components/listView/DefaultHeaderFormatter';

export const projectContentDefinition: IContentDefinition<Project, GetProjectsResult> = {
  getSectionTitle: () => Messages.ProjectSectionTitle(),
  getUrl: (urls) => urls.searchProjectsUrl(),
  getPath: (urls) => urls.searchProjectsPath(),
  defaultDisplayMode: 'list',
  listViewColumns: [
    CommonColumns.name,
    CommonColumns.owner,
    (parameters: IColumnFactoryParameters) => {
      return {
        name: 'created',
        dataKey: 'createdAt',
        sortable: false,
        headerText: Messages.column_created(),
        direction: 'desc',
        headerFormatter: defaultHeaderFormatter(),
        cellFormatter: DateTimeCell('createdAt'),
        growToFit: true,
      };
    },
    CommonColumns.description,
  ],
  maxItemCountInMixedContentTypeResultPage: 8,
  contentSpaceUrl: (urls: AppUrls, contentId: string) => urls.projectUrl(contentId),
  quickFilters: [ConnectedOwnerFilter, ConnectedModifiedTimeFilter],
  getMetaDataRequests: GetMetaDataRequests.GetProjectsRequest,
  mapCRASSData: (crassData: SearchResponseHitsContent[]) => {
    return crassData.map((crassDataItem: SearchResponseHitsContent) => {
      return {
        crassData: crassDataItem,
        contentType: ContentType.project,
        id: crassDataItem.id.toString() || '',
        name: crassDataItem.title || '',
        createdAt: crassDataItem.createdTime || '',
        description: crassDataItem.description || '',
      };
    });
  },
  mapMetadata: (searchResultItems, metadata) => {
    const projectMetadata: { [id: string]: IProject } = {};
    const userMetadata: { [id: string]: IUser } = {};
    const favoriteMetaData: { [id: string]: boolean } = {};
    if (metadata.total > 0) {
      metadata.items.projects.forEach((item) => {
        projectMetadata[item.id] = item;
      });
      metadata.items.users.forEach((item) => {
        userMetadata[item.id] = item;
      });
      metadata.items.favorites.forEach((id) => {
        favoriteMetaData[id] = true;
      });
    }

    return searchResultItems.map((searchResultItem) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const crassDataItem = searchResultItem.crassData!;

      const projectMetadataItem = projectMetadata[crassDataItem.id];
      const user = projectMetadataItem ? userMetadata[projectMetadataItem.ownerId] : undefined;
      return {
        ...searchResultItem,
        owner: UserMapper.mapOne(user),
        modifiedTime: projectMetadataItem ? projectMetadataItem.updatedAt : '',
        favorite: favoriteMetaData[crassDataItem.id.toString()] ? favoriteMetaData[crassDataItem.id.toString()] : false,
      };
    });
  },
  getSortOptions: () => [SortBy.getRelevancySortSelection()],
  shouldBeAvailable: () => true,
  favoritable: () => true,
};
